import ListIcon from "../ListIcon";
import classes from "./style.module.css";

const Footer = () => {
  return (
    <div className={classes.footer}>
      <ListIcon />
      <ListIcon />
      <ListIcon />
      <ListIcon />
      <ListIcon />
    </div>
  );
};

export default Footer;
